import React from "react";

export const TIMES = [
  "08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00",
  "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00",
  "15:30", "16:00", "16:30",
];

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const Step = ({ n, title, Icon, children }) => (
  <div>
    <div className="flex items-center gap-3 mb-5">
      <div className="h-10 w-10 border border-brand-red/40 bg-brand-red/10 rounded grid place-items-center"><Icon className="h-4 w-4 text-brand-red" /></div>
      <div>
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Step {n}</div>
        <div className="font-display uppercase text-lg text-white tracking-tight">{title}</div>
      </div>
    </div>
    {children}
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-400">{label}</span>
    <div className="mt-2">{children}</div>
  </label>
);

export const SummaryRow = ({ label, value }) => (
  <div className="flex items-start justify-between gap-4 text-sm">
    <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 whitespace-nowrap">{label}</span>
    <span className="text-right text-zinc-200 font-medium">{value || "—"}</span>
  </div>
);
